import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

import blackeye from "../../assets/images/clients/blackeye.png";
import irani from "../../assets/images/clients/irani.webp";
import chiyatown from "../../assets/images/clients/chiya-town.png";
import royal from "../../assets/images/clients/royal.jpg";
import omega from "../../assets/images/clients/omega.png";
import gayatri from "../../assets/images/clients/gayatri.webp";
import sb from "../../assets/images/clients/sb.png";
import everest from "../../assets/images/clients/everest.png";
import kanduka from "../../assets/images/clients/kanduka.png";
import amrathaan from "../../assets/images/clients/amrathaan.png";
import sbss from "../../assets/images/clients/sbss.webp";
import smile from "../../assets/images/clients/smile360.svg";

const clientLogos = [
  blackeye,
  irani,
  chiyatown,
  royal,
  omega,
  gayatri,
  sb,
  everest,
  kanduka,
  amrathaan,
  sbss,
  smile,
];

export default function Clients() {
  const settings = {
    infinite: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    cssEase: "linear",
    arrows: false,
    pauseOnHover: true,
    focusOnSelect: true,
    lazyload: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  useScrollReveal("slide-from-bottom");

  return (
    <>
      <div id="scroll" className="section section__about">
        <div className="container slide-from-bottom">
          <h3>
            Over <strong>10 companies</strong>
            <br /> rely on our professional skills and experience.
          </h3>
          <Slider
            {...settings}
            className="clients-slider"
            style={{ width: "auto" }}
          >
            {clientLogos.map((logo, index) => (
              <div key={index}>
                <img
                  loading="lazy"
                  alt="client"
                  src={logo}
                  style={{ marginTop: "30px", width:"90px" }}
                  // style={{width:"50px", height:"50px"}}
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </>
  );
}
